import React, { FunctionComponent, useCallback } from 'react';
import { TeamsFilesProps } from './types';
import { MeetingsFoldersShortcutsBrowser } from './MeetingsFoldersShortcutsBrowser';
import { MeetingsShortcutsList } from './MeetingsShortcutsList';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { meetingFilesSelectedSelectors } from '../../../../app/resource/meeting-shortcuts/meeting-shortcuts.selectors';
import { useParams } from 'react-router-dom';
import { IMeetingSimple } from '../../../../app/resource/meeting-simple/meeting-simple.types';

export const TeamsFiles: FunctionComponent<TeamsFilesProps> = () => {
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();
  const [meetingShortcutsSelected] = useSelectWithParams(meetingFilesSelectedSelectors.selectResourceList, meetingId);

  const dispatch = useDispatch();

  const openUploadFileFormDialog = useCallback(() => {
    dispatch(openDialog('meetingShortcutAddFileDialog'));
  }, [dispatch]);

  return (
    <div className="panel vto-text">
      <div className="panel-header small-header no-border pb-0">
        <h2 className="bold">Meeting Shortcuts</h2>
        <div className="ml-auto flex aic">
          {
            <button
              className={`btn btn-md popup_button ${meetingShortcutsSelected ? '' : 'light-theme-bg-color'}`}
              data-popup=""
              title="Add Event"
              disabled={meetingShortcutsSelected ? false : true}
              onClick={openUploadFileFormDialog}
              style={meetingShortcutsSelected ? {} : { pointerEvents: 'none' }}
            >
              <i className="icon-plus white f-1"></i> Add a Shortcut
            </button>
          }
        </div>
      </div>
      <div className="cards-container-overflow">
        <div className="cards-container">
          <div className="panel-body px-0 w100">
            <div className="border-radius-1 lightGray-bg p-2">
              <div className="row">
                <div className="col max-330">
                  <MeetingsFoldersShortcutsBrowser />
                </div>
                <div className="col">
                  <MeetingsShortcutsList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
